import { ThingsToDoAdd, ThingsToDoGrabber } from './ThingsToDoSidebar';
import { ThingsToDoEdit } from './ThingsToDoEdit';
import { ThingsToDoGuest } from './ThingsToDoGuest';
import { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const ThingsToDoConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/ThingsToDo_v1.7.0.json',
  componentType: 'ThingsToDo',
  adminSidebarComponent: {
    addComponentView: ThingsToDoAdd,
    dragComponentView: ThingsToDoGrabber,
    editComponentView: ThingsToDoEdit,
    createComponentView: ThingsToDoEdit,
  },
  guestSiteComponent: ThingsToDoGuest,
};
